/**
 * Client-location privacy helpers for public-facing views (contractor marketplace,
 * browse). We never expose a client's exact street address to browsing contractors.
 */

// Drop a leading street part (a number or a street-type word) and keep only the
// suburb/city — enough to gauge the area, not the doorstep. The full address is
// revealed later, after engagement, through the project's own pages.
export const coarseLocation = (loc) => {
  const raw = typeof loc === 'string' ? loc : (loc && loc.address) || '';
  if (!raw) return '';
  const parts = raw.split(',').map((s) => s.trim()).filter(Boolean);
  if (parts.length <= 1) return parts[0] || '';
  const streetRe = /\d|\b(road|rd|street|st|avenue|ave|crescent|cres|court|ct|drive|dr|close|lane|ln|way|place|pl|boulevard|blvd|highway|hwy|stand|plot|unit|apt|flat|suite)\b/i;
  const start = streetRe.test(parts[0]) ? 1 : 0;
  return parts.slice(start, start + 2).join(', ');
};

// The wizard auto-builds titles as "<work type> - <location>", which baked the
// full street address into the title. Strip the exact full-location substring
// out of a title and replace it with its coarse form. Retroactive at display
// time: works on every existing project's stored title with no data migration.
// No-op when the title doesn't contain the full location (e.g. hand-edited).
export const coarseTitle = (title, location) => {
  if (!title || typeof title !== 'string') return title || '';
  const loc = typeof location === 'string' ? location : (location && location.address) || '';
  if (!loc || !title.includes(loc)) return title;
  const coarse = coarseLocation(loc);
  if (coarse) return title.split(loc).join(coarse);
  // Nothing coarse to keep — drop the location and any trailing separator.
  return title.split(loc).join('').replace(/\s*[-–:,]\s*$/, '').trim();
};
